import type { ReactNode } from "react";
import { createPortal } from "react-dom";
import { DragOverlay } from "@dnd-kit/core";
import { useColumnDropAnimation } from "./columnSettingsMotion";

// Above the popover the list sits in (`$zindex-popover`, 1060).
const DRAG_OVERLAY_Z_INDEX = 1061;

/**
 * The drag overlay of a column settings list, for a `ColumnItemOverlay` of
 * the dragged row; it settles into the row's slot on drop.
 */
export const ColumnDragOverlay = ({
    children,
}: Readonly<{ children: ReactNode }>) => {
    const dropAnimation = useColumnDropAnimation();

    // Out of the popover: a fixed overlay inside its transformed positioner
    // measures off by the popover's offset, so drops miss.
    return createPortal(
        <DragOverlay
            dropAnimation={dropAnimation}
            zIndex={DRAG_OVERLAY_Z_INDEX}
        >
            {children}
        </DragOverlay>,
        document.body,
    );
};
